function cartUpsell() {
  return {
    upsellMessage: "",
    upsellSubMessage: "",
    upsellLink: "",
    upsellButtonLabel: "",
    upsellTags: ["Type_Euro Module", "Type_Euromodule Plate"],

    init() {
      // Patch the AM.addToCart function to check for upsells
      this.patchAddToCartFunction();
    },

    patchAddToCartFunction() {
      // Store the original addToCart function
      const originalAddToCart = AM.addToCart;
      const self = this;

      // Replace with our patched version
      AM.addToCart = function (formData, callback) {
        // Parse the form data to get product information before sending
        let productToCheck = null;

        try {
          if (typeof formData === "string") {
            // Handle JSON string format
            const parsedData = JSON.parse(formData);
            const variantId = parsedData.items[0].id;
            // Store variant ID to check after adding to cart
            productToCheck = variantId;
          } else if (formData instanceof FormData) {
            // Handle FormData format
            productToCheck = formData.get("id");
          }
        } catch (error) {
          console.error("Error parsing form data:", error);
        }

        // Call the original addToCart function with the correct context
        originalAddToCart.call(AM, formData, function () {
          // Run the original callback if provided
          if (callback) callback();

          // Check the product that was just added and show upsell if needed
          if (productToCheck) {
            self.checkProductForUpsell(productToCheck);
          }
        });
      };
    },

    async checkProductForUpsell(variantId) {
      try {
        const product = await this.fetchProductFromVariantId(variantId);
        if (product && this.shouldShowUpsell(product)) {
          this.setUpsellContent(product);
          this.showUpsellModal();
        }
      } catch (error) {
        console.error("Error checking product for upsell:", error);
      }
    },

    async fetchProductFromVariantId(variantId) {
      try {
        // Get the current product data from the page if available
        const productJson = document.querySelector("#product-variants");
        if (productJson) {
          const variants = JSON.parse(productJson.textContent);
          const currentVariant = variants.find((v) => v.id == variantId);

          if (currentVariant) {
            // Get product handle from URL or fallback to current page path
            const urlPath = window.location.pathname;
            const handle = urlPath.match(/\/products\/([^\/\?]+)/)?.[1];

            if (handle) {
              const response = await fetch(`/products/${handle}.json`);
              const productData = await response.json();
              return productData.product;
            }
          }
        }

        // Fallback: get product data from cart
        const cart = await AM.fetchCart();
        const cartItem = cart.items.find(
          (item) => item.variant_id == variantId
        );

        if (cartItem) {
          const response = await fetch(`/products/${cartItem.handle}.json`);
          const productData = await response.json();
          return productData.product;
        }

        return null;
      } catch (error) {
        console.error("Error fetching product data:", error);
        return null;
      }
    },

    shouldShowUpsell(product) {
      if (!product) return false;
      const productTags = product.tags ? product.tags.split(", ") : [];
      return this.upsellTags.some((tag) => productTags.includes(tag));
    },

    setUpsellContent(product) {
      const upsellContent = {
        "Type_Euro Module": {
          message:
            "This item is compatible for installation with our solid brass Euro Module Plates.",
          subMessage:
            "If plates are required as part of your order, please add them to your basket.",
          link: "/products/chamberlain-plain-euro-plate",
          buttonLabel: "Shop Euro Module Plates",
        },
        "Type_Euromodule Plate": {
          message: "Do you also require Euro Modules as part of this order?",
          subMessage: "If required, please add them to your basket.",
          link: "/collections/euromodules",
          buttonLabel: "Shop Euro Modules",
        },
      };

      // Find the matching tag from our upsellTags
      const matchingTag =
        product.tags &&
        product.tags
          .split(", ")
          .find((tag) => Object.keys(upsellContent).includes(tag));

      const content = matchingTag ? upsellContent[matchingTag] : null;

      if (!content) return;

      this.upsellMessage = content.message;
      this.upsellSubMessage = content.subMessage;
      this.upsellLink = content.link;
      this.upsellButtonLabel = content.buttonLabel;
    },

    showUpsellModal() {
      window.dispatchEvent(new CustomEvent("show-cart-upsell-modal"));
    },

    handleUpsellClick() {
      window.location.href = this.upsellLink;
    },
  };
}
